export function formatCurrency({
  price,
  currency,
  locale = 'en-SE',
  hideDecimals = false,
}: {
  price: number
  currency: string
  locale?: Intl.LocalesArgument
  hideDecimals?: boolean
}) {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    currencyDisplay: 'code',
    minimumFractionDigits: hideDecimals ? 0 : 2,
    maximumFractionDigits: hideDecimals ? 0 : 2,
  }).format(price / 100)
}
